import { render, staticRenderFns } from "./WorldTourCard.vue?vue&type=template&id=50def2ad&"
import script from "./WorldTourCard.vue?vue&type=script&lang=js&"
export * from "./WorldTourCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports